/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#activity-registry-wrapper[_ngcontent-%COMP%]{background-color:#f1f1f1;border-radius:1rem;padding:1rem 1rem .6rem;margin-top:.8rem}#activity-registry-items[_ngcontent-%COMP%]{width:100%;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:wrap;justify-content:space-around;-webkit-box-align:start;align-items:flex-start;align-content:space-around}#activity-registry-items-container[_ngcontent-%COMP%]{width:100%}lp2-activity-item[_ngcontent-%COMP%]{display:inline-block}.gamification[_ngcontent-%COMP%]   lp2-activity-item[_ngcontent-%COMP%]{width:8rem}#title[_ngcontent-%COMP%]{font-family:Nunito,Bold;font-size:1.12rem;text-align:left;width:100%}"];
export { styles as styles };
//# sourceMappingURL=activity-registry.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/activity-registry/activity-registry/activity-registry.component.scss.shim.ngstyle.js
// module id = 1689
// module chunks = 27 28 29